import * as React from 'react';
import { Res } from 'core/api';
import * as UI from 'core/ui';
import { Flex, FormComponent } from 'core/ui';
import { Binding, Result } from 'core/infrastructure';

type Props<T> = {
	linkTo: Binding.PropertyPath<T>;
	boundValue?: string;
}

type State = { customerDocumentNumber: string }

export class CustomerDocumentNumberComponent<T> extends React.Component<Props<T>, State> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
		this.state = { customerDocumentNumber: props.boundValue || '' };
	}

	getPath(): string {
		return Binding.propertyPathToString(this.props.linkTo);
	}

	showErrors(_errors: string[]): void {
	}

	getValue(): Result<string> {
		return Result.ok(this.state.customerDocumentNumber);
	}

	render() {

		const { TextBox } = UI.controlsFor<State>();
		return <Flex.Horizontal>
			<Flex.Item size='2ex' className='text-muted text-26 m-l-md'>
				<i className='fa fa-file-text-o'></i>
			</Flex.Item>
			<Flex.Item size='*' className='m-l-md' style={{ overflow: 'hidden' }}>
				<label className='m-t-xs'>{Res.Web.CONFIRM_DOCUMENT_DATA_CUSTOMER_DOCUMENT_NUMBER_PLACEHOLDER()}</label>
				<TextBox linkTo={x => x.customerDocumentNumber} maxLength={100} style={{ width: '90%' }} boundValue={this.state.customerDocumentNumber} onValueChange={value => this.setState({ customerDocumentNumber: value })} />
			</Flex.Item>
		</Flex.Horizontal>;
	}
}

export type CustomerDocumentNumberComponentCtor<T> = new (props: Props<T>) => React.Component<Props<T>, State>;
